export const getFileNameFromPath = (path: string) => {
  const pathArray = path.split("/");
  return pathArray[pathArray.length - 1];
};

export const isFile = (name: string) => {
  return getFileNameFromPath(name).split(".").pop();
};

export const downloadOvpnFile = (fileContent: string) => {
  const element = document.createElement("a");
  const file = new Blob([fileContent], { type: "text/plain" });
  element.href = URL.createObjectURL(file);
  element.download = "hotspring.ovpn";
  element.click();
};

export const getFirstDiffIndex = (name: string, existingNames: string) => {
  let i = 0;

  while (i < name.length && i < existingNames.length) {
    if (name[i] !== existingNames[i]) {
      break;
    }
    i++;
  }

  const versionIndex = name.indexOf("_v");
  let index: number;
  if (versionIndex > -1 && i < name.length) {
    index = Math.min(i, versionIndex);
  } else if (i < name.length) {
    index = i;
  } else {
    index = name.length;
  }

  return index;
};
